import React from 'react';
import {CircularProgress, Box} from '@mui/material';

const PendingContainer = ({isPending, children, containerStyle}) => {
    return (
      <Box position={isPending ? 'relative' : 'initial'} style={{overflow: 'hidden', ...containerStyle}}>
        <Box
          style={{
                    filter: isPending ? 'blur(4px)' : 'none',
                    transition: 'filter 0.3s',
                }}
        >
          {children}
        </Box>

        {isPending && (
          <Box
            position='absolute'
            top={0}
            left={0}
            right={0}
            bottom={0}
            style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                        backdropFilter: 'blur(4px)',
                        WebkitBackdropFilter: 'blur(4px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
          >
            <CircularProgress />
          </Box>
            )}
      </Box>
    );
};

export default PendingContainer;
